export const AUTH_STATUS_CHANGED_EVENT = "auth-status-changed";
export const LISTING_STATUS_CHANGED_EVENT = "listing-status-changed";
export const OPEN_SAVED_CLANS_EVENT = "open-saved-clans";
